export default "__VITE_ASSET__WDUVW9fj__"